import { DateInput } from '@core/components/Inputs';
import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { Grid } from '@material-ui/core';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import moment from 'moment';
import React from 'react';

const DadosCompra = ({
  onChange,
  onBlur,
  errors,
  touched,
  values,
  submitCount,
  onChangeDataPrimeiraParcela,
  compraPaga,
  onChangePreencherDataVencimento,
}) => {
  const _errors = {
    dataCompra: (submitCount > 0 || touched?.dataCompra) && errors?.dataCompra,
    fornecedor: (submitCount > 0 || touched?.fornecedor) && errors?.fornecedor?.id,
  };

  const handleChangeDataCompra = (e) => {
    onChange(e);
    onChangeDataPrimeiraParcela(moment(e.target.value, 'DD/MM/YYYY'));
    onChangePreencherDataVencimento(moment(e.target.value, 'DD/MM/YYYY'));
  };

  return (
    <Grid container spacing={3} className="mt-16">
      <Grid item xs={6} sm={6} md={6} lg={2} xl={2}>
        <ReadOnlyInput id="codigo" label="Identificador" value={values.codigo} />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={2} xl={2}>
        <DateInput
          id="dataCompra"
          name="dataCompra"
          onChange={handleChangeDataCompra}
          onBlur={onBlur}
          value={values.dataCompra}
          error={_errors.dataCompra}
          helperText={_errors.dataCompra}
          touched={!!_errors.dataCompra}
          required
          fullWidth
          variant="outlined"
          label="Data da compra"
          disabled={compraPaga}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
        <SelectFornecedor
          handleChange={onChange}
          handleBlur={onBlur}
          fornecedor={values?.fornecedor}
          error={_errors.fornecedor}
          touched={!!_errors.fornecedor}
          autoFocus
          disabled={compraPaga}
          required
        />
      </Grid>
    </Grid>
  );
};

export default DadosCompra;
